import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, XCircleIcon, TrendingDownIcon, HelpCircleIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const problems = [{
  icon: XCircleIcon,
  title: 'Gastas dinero en anuncios sin resultados',
  description: 'Inviertes en publicidad pero no ves retorno. Tu dinero desaparece sin generar ventas.'
}, {
  icon: HelpCircleIcon,
  title: 'No sabes cómo llegar a tu cliente ideal',
  description: 'Tus anuncios llegan a personas que nunca comprarán. No entiendes la segmentación.'
}, {
  icon: TrendingDownIcon,
  title: 'Tu competencia crece mientras tú te quedas atrás',
  description: 'Ves cómo otros negocios similares crecen con Meta Ads y tú no sabes cómo hacerlo.'
}, {
  icon: AlertTriangleIcon,
  title: 'Sientes que la publicidad digital es muy complicada',
  description: 'El Business Manager te confunde. No sabes por dónde empezar ni qué botón presionar.'
}];
export function ProblemSection() {
  return <section className="w-full bg-gray-50 py-20 sm:py-28" data-id="element-151">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-152">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-153">
          {/* Section header */}
          <motion.div variants={itemVariants} className="mb-12 text-center" data-id="element-154">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-red-100 px-4 py-2 text-sm font-semibold text-problem-red" data-id="element-155">
              <AlertTriangleIcon className="h-4 w-4" data-id="element-156" />
              El problema
            </span>
            <h2 className="font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-157">
              ¿Te identificas con esto?
            </h2>
          </motion.div>

          {/* Problem cards */}
          <div className="grid gap-6 md:grid-cols-2" data-id="element-158">
            {problems.map((problem, index) => {
            const IconComponent = problem.icon;
            return <motion.div key={index} variants={itemVariants} className="relative overflow-hidden rounded-2xl border-l-4 border-problem-red bg-white p-6 shadow-lg sm:p-8" data-id="element-159">
                  <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-red-50" data-id="element-160" />
                  <div className="relative" data-id="element-161">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-red-100" data-id="element-162">
                      <IconComponent className="h-6 w-6 text-problem-red" data-id="element-163" />
                    </div>
                    <h3 className="mb-2 font-heading text-xl font-bold text-gray-900" data-id="element-164">
                      {problem.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-165">{problem.description}</p>
                  </div>
                </motion.div>;
          })}
          </div>

          {/* Bottom message */}
          <motion.p variants={itemVariants} className="mt-12 text-center text-lg font-medium text-gray-700" data-id="element-166">
            Si esto te suena familiar,{' '}
            <span className="font-bold text-problem-red" data-id="element-167">no estás solo</span>.
            Miles de emprendedores enfrentan estos mismos desafíos.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}